package com.patronat.top.features.venues.domain.usecase.command

data class GetVenueDraftCommand(
    val venueId: String
)
